import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { bool } from "yup";

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#212121",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#0073E6",  // like mui blue 
      contrastText: "#212121",
    },
    background: {
      default: "#212121",
    },
    text: {
      primary: "#ffffff",
      secondary: "#b3b3b3",
    },
    divider: "#424242",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#212121",
          color: "#ffffff",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          color: "#ffffff",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          color: "#ffffff",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "#ffffff",
          "&:hover": {
            backgroundColor: "#1e1e1e",
          },
        },
      },
    },
    // Add TextField and OutlinedInput overrides
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'whitesmoke', // Default border
              boolWidth: '.1px', // Default border width
            },
            '&:hover fieldset': {
              borderColor: 'whitesmoke', // Hover border
              borderWidth: '.2px',   // Bold on hover
            },
            '&.Mui-focused fieldset': {
              borderColor: 'whitesmoke', // Focus border
              borderWidth: '2px',   // Bold on focus
            },
          },
          '& .MuiInputLabel-root': {
            color: 'whitesmoke', // Default label color
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: 'whitesmoke', // Focused label color
          },
          '& .MuiFormHelperText-root': {
            position: 'absolute',
            top: '-18px',
            margin: 0,
            width: '100%',
            fontSize: '10px',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        content: {
          margin: 0,
          '&.Mui-expanded': {
            margin: 0,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& fieldset': {
            borderColor: 'whitesmoke',
          },
          '&:hover fieldset': {
            borderColor: 'whitesmoke',
            borderWidth: '.1px',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'whitesmoke',
            borderWidth: '2px',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#ffffff",
          "&.Mui-checked": {
            color: "whitesmoke",
          },
        },
      },
    },
  },

});